import { FiTaskReportDateType } from '../fi-task-v2-report-enums';
import { IPeriodDateRange } from '@fi-shared/fi-time-range-menu/fi-time-range-menu';
import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { FiReportWidgetDateBase } from '@fi-shared/fi-report-widget/fi-report-widget-date-base';

@Injectable()
export class FiTask2ReportDateService extends FiReportWidgetDateBase<FiTaskReportDateType> {
    protected defaultTimePeriodType = FiTaskReportDateType.PastQuarter;

    constructor() {
        super();
    }
}
